import { render, staticRenderFns } from "./ProgressButton.vue?vue&type=template&id=2afc87a4&scoped=true&"
import script from "./ProgressButton.vue?vue&type=script&lang=ts&"
export * from "./ProgressButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressButton.vue?vue&type=style&index=0&id=2afc87a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc87a4",
  null
  
)

export default component.exports